module.exports = __webpack_public_path__ + "static/media/volume_up.594eeaa6.svg";